var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2343_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 21C2 20.449 2.449 20 3 20H10V18H6V2H18V11H20V2C20 0.897 19.103 0 18 0H3C1.346 0 0 1.346 0 3V21C0 22.654 1.346 24 3 24H12V22H3C2.449 22 2 21.551 2 21ZM3 2H4V18H3C2.648 18 2.314 18.072 2 18.184V3C2 2.449 2.449 2 3 2ZM24 18.664V19C24 20.104 23.105 21 22 21C20.895 21 20 20.104 20 19V18.664L20.842 16H19V22H22V24H14V22H17V16H15.179L16.109 18.599V19.174H16.096C15.982 20.201 15.112 21 14.054 21C12.919 21 12 20.08 12 18.946V18.613L13.5 14.001H17V13.001H19V14.001H22.5L24 18.665V18.664Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2343_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation);
export default __webpack_public_path__ + "static/media/consultation.e1d8b4d2c3b59452447a99fb7d346c8f.svg";
export { ForwardRef as ReactComponent };